// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import ScrollToElement from './ScrollToElement';

export default class AnchorSlider extends WebComponent {
  constructor (props) {
    super(props);

    this.scrollTo = this.scrollTo.bind(this);
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.handlePageload = this.handlePageload.bind(this);
  }

  didMount() {
    this.element.addEventListener('click', this.handleLinkClick);
    this.handlePageload();
  }

  handleLinkClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const href = e.target.getAttribute('href');
    const hash = `#${href.substring(href.indexOf('#') + 1)}`;
    this.scrollTo(hash);
    // window.location.hash = hash;
  };

  scrollTo = (targetId) => {
    const target = document.body.querySelector(targetId);
    new ScrollToElement(
      target,
      600,
      'easeOutQuad',
    );
  };

  handlePageload = () => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        this.scrollTo(hash);
      }, 1000);
    }
  };

  willUnMount() {

  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/AnchorSlider.js